import React from "react";
import AssetLibraryActions from "../../actions/AssetLibraryActions";
import GalleryAssetList from "./GalleryAssetList";

const addToGalleryList = () => AssetLibraryActions.addSelectedToList();
const removeFromGalleryList = () => AssetLibraryActions.removeSelectedFromList();
const reorderGalleryList = (moveData) => AssetLibraryActions.reorderList(moveData);
const selectGalleryListItem = (selection) => AssetLibraryActions.selectListItem(selection);
const expandGalleryView = () => AssetLibraryActions.expandGallery();
const contractGalleryView = () => AssetLibraryActions.contractGallery();

/**
 * The gallery chooser's "Gallery Images" list, wired to AssetLibraryStore.
 * @param {Object} props
 * @param {Array<Object>} props.galleryAssets
 * @param {boolean} props.galleryExpanded
 * @param {number} props.galleryItemsSelected
 * @param {number} props.numSelected library assets selected, for the add-to-list arrow
 * @param {boolean} props.galleryEditEnabled
 * @param {() => void} [props.onAddToList] defaults to adding the selected library assets
 * @param {string} [props.addToListLabel] shown on the add arrow in place of the selection count
 */
const GalleryEditList = React.memo(
  ({
    galleryAssets,
    galleryExpanded,
    galleryItemsSelected,
    numSelected,
    galleryEditEnabled,
    onAddToList = addToGalleryList,
    addToListLabel,
  }) => (
    <GalleryAssetList
      assets={galleryAssets}
      expanded={galleryExpanded}
      numSelected={galleryItemsSelected}
      numAssetsSelected={numSelected}
      addToListEnabled={numSelected > 0}
      onAddToList={onAddToList}
      addToListLabel={addToListLabel}
      onRemoveFromList={removeFromGalleryList}
      onItemSelect={selectGalleryListItem}
      onReorderList={reorderGalleryList}
      onExpand={expandGalleryView}
      onContract={contractGalleryView}
      galleryEditEnabled={galleryEditEnabled}
    />
  ),
);

export default GalleryEditList;
